import { CustomField } from 'admin/customFields/entities/customFields.entity';

import List from '@mui/material/List';
import { FilterListItem } from 'common/components/Filters/FilterListItem';
import { useEnabledCustomFieldFromQueryCache } from 'admin/customFields/hooks/useEnabledCustomFieldFromQueryCache';
import { WritableAtom } from 'jotai';
import { CustomFieldInput } from './CustomFieldInput';
import { CustomFields } from 'src/simInventory/models/SimProfile.model';
import { customFieldsHintsAtom } from 'src/atoms/hints/sim';

type CustomFieldInputsProps = {
  customFieldsFilterAtom: WritableAtom<CustomFields, [CustomFields], void>;
  customFieldsHintsAtom: typeof customFieldsHintsAtom;
};

export const CustomFieldInputs = ({
  customFieldsFilterAtom,
  customFieldsHintsAtom,
}: CustomFieldInputsProps) => {
  const { data: customFieldsData, isFetched } = useEnabledCustomFieldFromQueryCache();

  return isFetched ? (
    <List>
      {customFieldsData?.map((field: CustomField) => {
        return (
          <FilterListItem key={field.id} label={field.label} htmlFor={field.id.toString()}>
            <CustomFieldInput
              name={field.label}
              type={field.dataType || 'Text'}
              id={field.id}
              selectionOptions={field.selectionOptions}
              customFieldsFilterAtom={customFieldsFilterAtom}
              customFieldsHintsAtom={customFieldsHintsAtom}
            />
          </FilterListItem>
        );
      })}
    </List>
  ) : null;
};
